import React from "react";
import PropTypes from "prop-types";
import Button from "components/Button";
import Alert from "components/Alert";
import useAsync from "hooks/useAsync";
import useToast from "hooks/useToast";
import deleteRESaleService from "services/re/deleteRESaleService";

function DeleteRESale({ re, onDelete }) {
  const { showSuccess, showError } = useToast();
  const [alertVisible, setAlertVisible] = React.useState(false);

  const [fetch, pending] = useAsync({
    promiseFn: deleteRESaleService,
    onError: error => {
      showError("Error deleting RE");
    },
    onData: () => {
      showSuccess("RE deleted successfully.");
      onDelete();
    }
  });

  return (
    <>
      <Button
        size="sm"
        icon="trash"
        onClick={() => setAlertVisible(true)}
        loading={pending}
      />
      <Alert
        isOpen={alertVisible}
        onConfirm={() => fetch({ saleId: re.sale_id })}
        intent="danger"
        icon="trash"
        onCancel={() => setAlertVisible(false)}
      >
        Are you sure you want to delete the Sale <b>{re.sale_id}</b>?
      </Alert>
    </>
  );
}

DeleteRESale.propTypes = {
  re: PropTypes.object,
  onDelete: PropTypes.func.isRequired
};

DeleteRESale.defaultProps = {
  re: {}
};

export default DeleteRESale;
